<script>
import debounce from 'lodash.debounce'
import axios from 'axios'
import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/vue'
import TwLoadingSpinnerMini from '@/components/generic/tw-loading-spinner-mini.vue'
import HomeSearchResultListItem from '@/components/home/home-search-result-list-item.vue'

export default {
  components: {
    HomeSearchResultListItem,
    TwLoadingSpinnerMini,
    MagnifyingGlassIcon,
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
  },
  props: {
    backend: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: null,
      LoadingSearching: false,
      ValidationErrorMessage: null,
      Results: {},
      DialogOpened: true,
      SearchQuery: '',
      searchDebounced: null,
    }
  },
  computed: {
    searchUrl() {
      return this.backend ? '/api/v1/search-backend' : '/api/v1/search'
    }
  },
  created() {
    this.searchDebounced = debounce(this.search, 500)
  },
  methods: {
    async search(SearchQuery) {
      if (!SearchQuery || SearchQuery.length < 3) return
      try {
        this.ValidationErrorMessage = null
        this.LoadingSearching = true
        const { data } = await axios.get(this.searchUrl, { params: { query: SearchQuery } })
        this.Results = data
        this.LoadingSearching = false
      } catch (e) {
        console.error(e)
        this.LoadingSearching = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    onSelect(result) {
      if (result) {
        if (this.backend) {
          // we doin' the vue redirect
          if(result.object_type_short === 'FundraiserPage') {
            this.$router.push({ name: 'FundraiserPageDashboardPage', params: { fundraiserPageId: result.id  } })
          } else if(result.object_type_short === 'Fundraiser') {
            this.$router.push({ name: 'FundraiserDashboardPage', params: { fundraiserId: result.id } })
          }
        } else {
          console.log(result.object_type_short)
          // we use the public routes
          if(result.object_type_short === 'FundraiserPage') {
            this.$router.push({ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: result.id, slug: result.slug  } })
          } else if(result.object_type_short === 'Fundraiser') {
            this.$router.push({ name: 'FundraiserPublicPage', params: { fundraiserId: result.id, slug: result.slug } })
          } else if(result.object_type_short === 'Team') {
            this.$router.push({ name: 'FundraiserTeamPublicPage', params: { teamId: result.id, fundraiserId: result.fundraiser_id } })
          }
        }
      }
    },
  },
}
</script>

<template>
  <div class="w-full">
    <Combobox @update:model-value="onSelect">
      <div class="grid grid-cols-1">
        <ComboboxInput class="col-start-1 row-start-1 min-h-12 w-full pl-10 pr-3 text-base border-gray-200 text-gray-900 outline-none placeholder:text-gray-400 rounded-lg" placeholder="Search..." @keyup.enter="onSelect(active)" @change="searchDebounced($event.target.value)" @blur="SearchQuery = ''" />
        <MagnifyingGlassIcon class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-600" aria-hidden="true" />
      </div>
      <ComboboxOptions v-if="LoadingSearching || (Results && Results.length > 0)" static class="rounded-md mt-1 py-2 max-h-72 scroll overflow-y-auto text-sm text-gray-900 bg-white absolute w-[calc(100%-34px)] md:w-[500px]">
        <ComboboxOption v-if="LoadingSearching" as="template" class="flex justify-center items-center bg-white">
          <div><tw-loading-spinner-mini class="p-4" /></div>
        </ComboboxOption>

        <home-search-result-list-item v-for="item in Results" :key="item.id" :active="active" :search-result-item="item" :fundraiser-page="item" />
      </ComboboxOptions>
      <p v-else-if="SearchQuery && SearchQuery.length > 3" class="p-4 text-sm text-gray-500 bg-white">
        No fundraisers found.
      </p>
    </Combobox>
  </div>
</template>

<style scoped></style>
